import React, { useContext, useEffect, useState } from "react"
import Swal from "sweetalert2"
import MyContext from "../ContextApi/MyCOntext"

export default function AddProducts() {
    const { Categories, allProducts } = useContext(MyContext)
    const [attribute, setAttribute] = useState({
        key: "",
        value: ""
    })
    const [attributeData, setAttributeData] = useState([])
    const [selectedAttributes, setSelectedAttributes] = useState({});

    const [displayedAttributes, setDisplayedAttributes] = useState([]);
    const user = JSON.parse(sessionStorage.getItem("signUp"))

    const [product, setProduct] = useState({
        title: "",
        price: "",
        description: "",
        images: [],
        categoryId: ""
    })
    // add product
    const addProduct = async (e) => {
        e.preventDefault();
        // Destructure product state
        const { title, price, description, images, categoryId } = product;

        // Error handling elements
        const titleError = document.getElementById("titleError");
        const categoryIdError = document.getElementById("categoryIdError");
        const priceError = document.getElementById("priceError");
        const descriptionError = document.getElementById("descriptionError");
        const imageError = document.getElementById("imageError");

        let emptyFieldError = false;

        // Validation
        if (!categoryId) {
            categoryIdError.innerText = "Please select a category";
            emptyFieldError = true;
        } else {
            categoryIdError.innerText = "";
        }

        if (!title) {
            titleError.innerText = "Please enter a title";
            emptyFieldError = true;
        } else {
            titleError.innerText = "";
        }

        if (!description) {
            descriptionError.innerText = "Please add a description";
            emptyFieldError = true;
        } else {
            descriptionError.innerText = "";
        }

        if (!images || images.length === 0) {
            imageError.innerText = "Please select at least one image";
            emptyFieldError = true;
        } else if (images.length > 5) {
            imageError.innerText = "You can upload up to 5 images only";
            emptyFieldError = true;
        } else {
            imageError.innerText = "";
        }

        if (!price) {
            priceError.innerText = "Please enter the product price";
            emptyFieldError = true;
        } else {
            priceError.innerText = "";
        }

        if (emptyFieldError) {
            return;
        }

        const formData = new FormData();
        formData.append("title", title);
        formData.append("price", price);
        formData.append("description", description);
        formData.append("categoryId", categoryId);
        formData.append("userId", user._id);

        // Append images
        for (let i = 0; i < images.length; i++) {
            formData.append("images", images[i]);
        }
        // formData.append("variations", JSON.stringify(selectedAttributes))
        try {
            const res = await fetch("http://localhost:8000/api/auth/addProducts", {
                method: "POST",
                body: formData
            });

            const data = await res.json();

            if (!res.ok) {
                console.log(`Error: ${res.status} - ${res.statusText}`);
                if (data.message === "Title already used") {
                    titleError.innerText = "Title already used";
                }
                return;
            }

            setProduct({
                title: "",
                price: "",
                description: "",
                images: [],
                categoryId: ""
            });

            Swal.fire({
                position: "center",
                icon: "success",
                title: "Product has been uploaded",
                showConfirmButton: false,
                timer: 1500
            });

            allProducts();

        } catch (error) {
            console.error("Error uploading product:", error);
        }
    };

    const onchange = (e) => {
        const { name, value, files } = e.target;
        if (name === "images") {
            setProduct({ ...product, images: files });
        } else {
            setProduct({ ...product, [name]: value });
        }
    };

    const AddAttribute = () => {
        const data = JSON.parse(sessionStorage.getItem("attribute")) || []
        data.push(attribute)
        sessionStorage.setItem("attribute", JSON.stringify(data))
        setAttribute({
            key: "",
            value: ""
        })
    }
    const onAttributeChange = (e) => {
        setAttribute({ ...attribute, [e.target.name]: e.target.value })
    }

    const handleSave = () => {
        const data = JSON.parse(sessionStorage.getItem("selectedAttribute")) || []
        data.push(selectedAttributes)
        sessionStorage.setItem("selectedAttribute", JSON.stringify(data))
    }
    const handleAttributeChange = (key, value) => {
        setSelectedAttributes({ ...selectedAttributes, [key]: value })
    };
    useEffect(() => {
        const data = JSON.parse(sessionStorage.getItem("attribute")) || []
        setAttributeData(data)
        const displayData = JSON.parse(sessionStorage.getItem("selectedAttribute")) || []
        console.log(displayData);

        setDisplayedAttributes(displayData)
    }, [attribute, selectedAttributes])

    return (
        <div className="container pt-4">
            <div className="d-flex justify-content-end">
                <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Add Product Variations</button>
            </div>
            <form onSubmit={addProduct} encType="multipart/form-data">
                <div className="row py-5">
                    <div className="col-md-6">
                        <div id="error" className="text-danger text-center"></div>

                        {/* Existing Fields */}
                        <input className="form-control" type="text" placeholder="Product Title" name="title" value={product.title} onChange={onchange} />
                        <div id="titleError" className="text-danger"></div>

                        <select name="categoryId" value={product.categoryId} onChange={onchange} id="category" className="form-control mt-3">
                            <option value="">Select Category</option>
                            {Categories && Categories.map((category) => (
                                <option key={category._id} value={category._id}>{category.category}</option>
                            ))}
                        </select>
                        <div id="categoryIdError" className="text-danger"></div>


                    </div>
                    <div className="col-md-6">
                        <input className="form-control" type="number" placeholder="Product Price" name="price" value={product.price} onChange={onchange} />
                        <div id="priceError" className="text-danger"></div>

                        <label htmlFor="file" className="mt-3">Add Product Images (up to 5)</label>
                        <input className="form-control mt-2" id="file" type="file" placeholder="Image" name="images" onChange={onchange} multiple />
                        <div id="imageError" className="text-danger"></div>
                    </div>
                    <div className="col-md-12">
                        <textarea className="form-control mt-3" cols="30" rows="10" placeholder="Product Description" name="description" value={product.description} onChange={onchange}></textarea>
                        <div id="descriptionError" className="text-danger"></div>
                    </div>
                    <div className="col-md-12 d-flex justify-content-center">
                        <button type="submit" className="btn btn-danger mt-3 text-center px-4 py-2">Upload Product</button>
                    </div>

                </div >
            </form>

            {/* modal */}
            <div>

                <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="staticBackdropLabel">Modal title</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div className="row justify-content-between">
                                    <div className="col-md-12">
                                        <input type="text" name="key" value={attribute.key} onChange={onAttributeChange} placeholder="type: eg.color,size" className="form-control" />
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <input type="text" name="value" value={attribute.value} onChange={onAttributeChange} placeholder="values: eg.red,small. Seperate values using |" className="form-control" />
                                    </div>
                                    <div className="d-flex justify-content-center mt-3">
                                        <button className="btn btn-danger" onClick={AddAttribute}>Add Attribute</button>
                                    </div>

                                    {/* attribute data */}
                                    <div>
                                        {attributeData && attributeData.map(data => (
                                            <div className="pt-3">
                                                <select class="form-select" aria-label="Default select example" onChange={(e) => handleAttributeChange(data.key, e.target.value)}>
                                                    <option selected>Select {data.key}</option>
                                                    {data.value.split('|').map(option => (
                                                        <option value={option.trim()}>{option.trim()}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        ))}

                                        <button className="btn btn-danger mt-3" onClick={handleSave}>Save</button>
                                    </div>
                                    {displayedAttributes && (
                                        <div className="mt-2">
                                            {displayedAttributes.map((attributes, index) => (
                                                <div key={index}>
                                                    {Object.entries(attributes).map(([key, value], idx) => (
                                                        <input key={idx} type="text" value={value} />
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}